export default __webpack_public_path__ + "static/media/history.2c92cfe3.png";